import DiagnosticHypothesisConfig from "@/views/configs/diagnostic_hypothesis/index.vue";
import DiagnosticHypothesisSiteConfig from "@/views/configs/diagnostic_hypothesis/site.vue";
import DiagnosticHypothesisCidConfig from "@/views/configs/diagnostic_hypothesis/cid.vue";

export default [
  {
    path: "hipotese-diagnostica",
    component: DiagnosticHypothesisConfig,
    children: [
      {
        path: "local",
        name: "H.D local",
        component: DiagnosticHypothesisSiteConfig,
      },
      {
        path: "",
        name: "H.D Cid",
        component: DiagnosticHypothesisCidConfig,
      },
    ],
  },
];
